import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSuggestions } from "../api/client"; // Import your new hook

export default function SearchBar() {
    const [query, setQuery] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const navigate = useNavigate();
    const wrapperRef = useRef<HTMLDivElement>(null);

    // Use your TanStack hook
    const { data: suggestions = [], isFetching } = useSuggestions(query);

    // Close dropdown on click outside
    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const handleSearchSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmedQuery = query.trim();

        setShowSuggestions(false);

        navigate(`/phones?q=${encodeURIComponent(trimmedQuery)}&page=0`);
    };
    return (
        <div ref={wrapperRef} className="relative w-full max-w-md">
            <form onSubmit={handleSearchSubmit} className="flex items-center bg-white rounded-xl shadow-sm border px-3 py-2">
                <input
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onFocus={() => setShowSuggestions(true)}
                    placeholder="Search devices..."
                    className="flex-1 outline-none text-sm"
                />
                {isFetching && (
                    <div className="animate-spin h-4 w-4 border-2 border-blue-500 rounded-full border-t-transparent ml-2" />
                )}
            </form>

            {showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-[100] w-full bg-white border rounded-b-xl shadow-lg mt-1 overflow-hidden">
                    {suggestions.map((item) => (
                        <li
                            key={item.id}
                            onClick={() => {
                                navigate(`/phones/${item.id}`);
                                setShowSuggestions(false);
                            }}
                            className="px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm border-b last:border-none flex justify-between items-center"
                        >
                            <span>{item.text}</span>
                            <span className="text-xs text-gray-400">View Details</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}